import { render, staticRenderFns } from "./StyleService.vue?vue&type=template&id=1186627a&scoped=true"
import script from "./StyleService.vue?vue&type=script&lang=js"
export * from "./StyleService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186627a",
  null
  
)

export default component.exports